import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../context/AppContext";

export default function EcommerceSidebar({ isOpen, onClose }) {
  const navigate = useNavigate();
  const { user, resetUserContext } = useContext(AppContext);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setVisible(false);
      return undefined;
    }

    const timer = setTimeout(() => setVisible(true), 10);
    return () => clearTimeout(timer);
  }, [isOpen]);

  if (!isOpen) return null;

  const fullName = user?.fullName || localStorage.getItem("ecomm_fullName") || "Guest User";
  const mobile = user?.mobileNo || localStorage.getItem("mobileNo") || localStorage.getItem("ecomm_mobileNo") || "";

  const goTo = (path) => {
    onClose();
    navigate(path);
  };

  const handleLogout = () => {
    resetUserContext();
    localStorage.removeItem("ecomm_cart");
    localStorage.removeItem("ecomm_isLoggedIn");
    sessionStorage.removeItem("ecomm_isLoggedIn");
    onClose();
    navigate("/", { replace: true });
  };

  return (
    <div className="ecomm-sidebar-layer">
      <div className={`ecomm-sidebar-overlay ${visible ? "open" : ""}`} onClick={onClose} />
      <aside className={`ecomm-sidebar ${visible ? "open" : ""}`}>
        <div className="ecomm-sidebar-profile">
          <button className="ecomm-sidebar-close" onClick={onClose} aria-label="Close menu">
            x
          </button>

          <div className="ecomm-profile-row">
            <svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="#ff2600" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
              <circle cx="12" cy="7" r="4" />
            </svg>
            <div className="ecomm-profile-text">
              <h3>{fullName}</h3>
              <p>{mobile ? `+91 ${mobile}` : "Not Registered"}</p>
            </div>
          </div>
        </div>

        <div className="ecomm-sidebar-menu">
          <SidebarButton label="Home" onClick={() => goTo("/home")}>
            <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
          </SidebarButton>
          <SidebarButton label="My Orders" onClick={() => goTo("/order-history")}>
            <path d="M6 4h12" />
            <path d="M6 9h12" />
            <path d="M6 4a5 5 0 0 1 0 10h6" />
            <path d="m11 14-6 6" />
          </SidebarButton>
          <SidebarButton label="Change Password" onClick={() => goTo("/set-new-pin")}>
            <circle cx="12" cy="12" r="3" />
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
          </SidebarButton>
          <SidebarButton label="Privacy Policy" onClick={() => goTo("/privacy-policy")}>
            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </SidebarButton>
          <SidebarButton label="Terms & Conditions" onClick={() => goTo("/terms-conditions")}>
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="16" y1="13" x2="8" y2="13" />
          </SidebarButton>
          <SidebarButton label="Refund Policy" onClick={() => goTo("/refund-policy")}>
            <path d="M21 12a9 9 0 1 1-3-6.7" />
            <path d="M21 3v6h-6" />
            <path d="M12 7v5l3 2" />
          </SidebarButton>
          <SidebarButton label="Delete Account" onClick={() => goTo("/delete-account")} plainIcon>
            <polyline points="3 6 5 6 21 6" />
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
            <line x1="10" y1="11" x2="10" y2="17" />
            <line x1="14" y1="11" x2="14" y2="17" />
          </SidebarButton>

          <div className="ecomm-sidebar-separator" />

          <SidebarButton label="Log out" onClick={handleLogout} logout>
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </SidebarButton>
        </div>
      </aside>
    </div>
  );
}

function SidebarButton({ label, onClick, children, logout = false, plainIcon = false }) {
  return (
    <button type="button" className={`ecomm-sidebar-btn ${logout ? "logout" : ""}`} onClick={onClick}>
      <span className={plainIcon ? "ecomm-sidebar-plain-icon" : "ecomm-sidebar-icon-circle"}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          {children}
        </svg>
      </span>
      <span>{label}</span>
    </button>
  );
}
